import React from 'react';
import { withRouter } from 'react-router-dom';

import './MenuItem.css';

const MenuItem = (props) => {
  const {
    menuItem: {
      icon,
      path,
      subItems,
      name,
    },
    history,
    location,
    activeItem,
    setActiveItem,
  } = props;

  const isActive = activeItem
    ? activeItem === name
    : location.pathname === path || (subItems && subItems.some(subItem => subItem.path === location.pathname));

  const onClick = () => {
    if (subItems) {
      if (activeItem === name) {
        setActiveItem("");
      } else {
        setActiveItem(name);
      }
    } else {
      setActiveItem("");
      history.location.pathname !== path && history.push(path)
    }
  }

  return (
    <div
        className={`MenuItem ${isActive ? 'MenuItem--active' : ''}`}
        onClick={onClick}
      >
        <i className={`${icon} MenuItem__Icon`} />
        {subItems &&
          <div className={`MenuItem__SubItems ${activeItem === name ? 'MenuItem__SubItems--active' : ''}`}>
            {subItems.map(subItem =>
              <div key={subItem.name} className="SubItems__Item" onClick={() => history.push(subItem.path)}>
                <i className={subItem.icon} />
                <span>{subItem.name}</span>
              </div>  
            )}
          </div>
        }
      </div>
  )
}

export default withRouter(MenuItem);

